import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Widget, Demo } from './Widget';
createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {location.pathname === '/widget' ? (
      <Widget />
    ) : location.pathname === '/demo' ? (
      <Demo />
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
